import React, { useEffect, useMemo, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { PRODUCTION_SHIPPING_TAB_ROUTES, getProductionShippingPathForTab, getProductionShippingTabFromPath } from '../../config/productionRoutes';
import TopNav from '../TopNav/TopNav';
import ShippingChangeLog from './ShippingChangeLog';
import ShippingDashboard from './ShippingDashboard';
import PackingListStatus from './PackingListStatus';
import ShippingOnHoldJobs from './ShippingOnHoldJobs';
import '../JobSchedulePage/JobScheduleResponsive.css';

export default function ShippingContainer() {
  const { canView, canEdit, isLoading } = usePermissions();
  const location = useLocation();
  const navigate = useNavigate();
  const [fullScreen, setFullScreen] = useState(false);
  const [scheduleFilters, setScheduleFilters] = useState({ range: '3', search: '' });
  const visibleTabs = useMemo(() => PRODUCTION_SHIPPING_TAB_ROUTES.filter((tab) => canView(tab.permissionKey)), [canView]);
  const requestedTab = getProductionShippingTabFromPath(location.pathname);
  const activeTab = visibleTabs.some((tab) => tab.id === requestedTab) ? requestedTab : visibleTabs[0]?.id;
  const displayFullScreen = activeTab === 'display' && fullScreen;
  useEffect(() => { setFullScreen(false); }, [activeTab]);
  useEffect(() => {
    if (isLoading || !canView('shipping.container') || !activeTab) return;
    const path = getProductionShippingPathForTab(activeTab);
    if (location.pathname !== path) navigate(path, { replace: true });
  }, [activeTab, canView, isLoading, location.pathname, navigate]);

  if (isLoading) return <><TopNav /><p className="p-4" role="status">Loading shipping permissions...</p></>;
  if (!canView('shipping.container')) return <Navigate to="/" replace />;
  return <>{!displayFullScreen && <TopNav />}<main className={displayFullScreen ? 'shipping-fullscreen-container' : 'container-fluid p-3'}>
    {!displayFullScreen && <>
    <h1 className="h3">Shipping</h1>
    <nav aria-label="Shipping tabs" className="nav nav-tabs mb-4">
      {visibleTabs.map((tab) => <button key={tab.id} type="button" className={`nav-link ${activeTab === tab.id ? 'active' : ''}`} aria-current={activeTab === tab.id ? 'page' : undefined} onClick={() => navigate(tab.path)}>{tab.label}</button>)}
    </nav>
    </>}
    {!activeTab && <Alert variant="warning">You do not currently have access to any shipping tabs. Contact an administrator to update your component policies.</Alert>}
    {['display', 'data-entry', 'end-of-shift', 'shipping-details'].includes(activeTab) && <ShippingDashboard key={activeTab} view={activeTab} canEdit={canEdit(`shipping.${activeTab}`)} fullScreen={displayFullScreen} onFullScreenChange={setFullScreen} scheduleFilters={scheduleFilters} onScheduleFiltersChange={setScheduleFilters} />}
    {activeTab === 'change-log' && <ShippingChangeLog key={activeTab} />}
    {activeTab === 'packing-list-status' && <PackingListStatus />}
    {activeTab === 'on-hold-ready-to-ship' && <ShippingOnHoldJobs />}
  </main></>;
}
